/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const ADD_TO_CART = gql`
  mutation CreateCart($data: BoxCreateInput!) {
    createCart(data: $data) {
      _id
      referal
      totalAmount
      user {
        id
        email
      }
      presentation {
        id
        name
      }
      section {
        id
        name
      }
      items {
        quantity
        costumeType {
          id
          name
        }
        costumeFeature {
          id
          name
        }
        costumeAttribute {
          id
          name
        }
        costumeValue {
          id
          name
        }
      }
    }
  }
`;
